import { updateUsersTenants } from '@api/users';
import { Button } from '@mui/material';
import React from 'react';
import { ITenantsRolesEdit } from 'types/users';
import UserEditTenantDialog from './UserEditTenantDialog';

interface IUserEditTenantButtonProps {
	ids: string[];
	onApprove: () => Promise<void>;
}

const UserEditTenantButton: React.FC<IUserEditTenantButtonProps> = ({
	ids,
	onApprove
}) => {
	const [open, setOpen] = React.useState(false);

	const handleBatchEditTenantsAction = React.useCallback(
		async (data?: ITenantsRolesEdit) => {
			await updateUsersTenants({
				ids,
				mappings: data?.mappings,
				operation: data?.operation
			});
			await onApprove();
		},
		[ids, onApprove]
	);

	const handleClick = React.useCallback(() => {
		setOpen(!open);
	}, [setOpen, open]);

	const handleSubmit = React.useCallback(
		(tenants?: ITenantsRolesEdit) => {
			setOpen(false);
			return handleBatchEditTenantsAction(tenants);
		},
		[handleBatchEditTenantsAction]
	);

	return (
		<>
			<Button
				variant="outlined"
				size="small"
				data-testid="users-edit-user-tenant-button"
				onClick={handleClick}
				// Same margin as user batch action
				sx={{
					mr: 2,
					textOverflow: 'ellipsis',
					whiteSpace: 'nowrap',
					overflow: 'hidden',
					display: 'block',
					mt: {
						xs: 2,
						sm: 0
					}
				}}
			>
				{intl.tr('button.editTenant')}
			</Button>
			{open && (
				<UserEditTenantDialog onSubmit={handleSubmit} onCancel={handleClick} />
			)}
		</>
	);
};

export default UserEditTenantButton;
